import {Platform} from 'react-native';
import {useSelector} from 'react-redux';
import View from './view';
import {documentsSelector} from '../../../../../../redux/selectors/documents';
import {useEffect} from 'react';
import {getDocumentFileMobile, getDocumentFileWeb, getDocuments} from '../../../../../../redux/actions/documents';
import {buildDocumentName, Document, sortInPlaceDocumentsByUpdateDate} from '../../../../common/documents/model';
import {useAppDispatch} from '../../../../../../redux';

export const DocumentsListItem = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getDocuments());
  }, []);
  const documents = useSelector(documentsSelector);
  const handlePressDocumentCard = (document: Document) => {
    const params = {id: document.id, type: document.type, fileName: buildDocumentName(document)};

    if (Platform.OS === 'web') {
      const thunk = getDocumentFileWeb(params);
      if (thunk) dispatch(thunk);
    }
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      const thunk = getDocumentFileMobile(params);
      if (thunk) dispatch(thunk);
    }
  };
  const handleRefresh = () => dispatch(getDocuments());
  return View({documents: sortInPlaceDocumentsByUpdateDate([...documents]), handlePressDocumentCard, handleRefresh});
};
